import { Shield, Mail, Phone, MapPin, Calendar, Eye, Lock, Database, UserCheck, AlertTriangle } from 'lucide-react'

const PolitiqueConfidentialite = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      {/* Header */}
      <div className="bg-white shadow-sm">
        <div className="container-custom py-8">
          <div className="flex items-center mb-4">
            <Shield className="h-8 w-8 text-orange-500 mr-3" />
            <h1 className="text-3xl font-bold text-gray-900">Politique de confidentialité</h1>
          </div>
          <p className="text-gray-600">
            Dernière mise à jour : {new Date().toLocaleDateString('fr-FR', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>
      </div>

      {/* Content */}
      <div className="container-custom py-12">
        <div className="bg-white rounded-lg shadow-sm p-8">
          
          {/* Introduction */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Shield className="h-6 w-6 text-orange-500 mr-2" />
              Introduction
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                FLIGHTCASE FWI SASU (ci-après "nous", "notre" ou "nos") s'engage à protéger votre vie privée et vos données personnelles. Cette politique de confidentialité explique comment nous collectons, utilisons, stockons et protégeons vos informations personnelles lorsque vous utilisez notre site web et nos services.
              </p>
              <p>
                En utilisant notre site web ou en nous fournissant vos données personnelles, vous acceptez les pratiques décrites dans cette politique de confidentialité.
              </p>
            </div>
          </section>

          {/* Responsable du traitement */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Database className="h-6 w-6 text-orange-500 mr-2" />
              Responsable du traitement des données
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Le responsable du traitement de vos données personnelles est :
              </p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="space-y-2">
                  <p><strong>FLIGHTCASE FWI SASU</strong></p>
                  <p>SIRET : 882 469 174 00016</p>
                  <p>Adresse : HOTEL LA TOUBANA SECTION DURIVAGE, 97180 SAINTE-ANNE</p>
                  <p>Email : contact@flightcasefwi.com</p>
                  <p>Téléphone : +590 590 265 430</p>
                </div>
              </div>
            </div>
          </section>

          {/* Données collectées */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Eye className="h-6 w-6 text-orange-500 mr-2" />
              Données personnelles collectées
            </h2>
            <div className="space-y-6">
              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.1 • Données collectées directement</h3>
                <div className="space-y-3 text-gray-700">
                  <p>Nous collectons les données personnelles que vous nous fournissez volontairement :</p>
                  <ul className="ml-6 space-y-2">
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Informations d'identification :</strong> nom, prénom, adresse email, numéro de téléphone</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Informations de facturation :</strong> adresse de facturation, informations de paiement</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Informations professionnelles :</strong> nom de l'entreprise, SIRET, secteur d'activité</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Préférences :</strong> matériel préféré, listes de souhaits</span>
                    </li>
                  </ul>
                </div>
              </div>

              <div>
                <h3 className="text-xl font-semibold text-gray-900 mb-4">2.2 • Données collectées automatiquement</h3>
                <div className="space-y-3 text-gray-700">
                  <p>Lors de votre navigation sur notre site, nous collectons automatiquement :</p>
                  <ul className="ml-6 space-y-2">
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Données de navigation :</strong> adresse IP, type de navigateur, pages visitées, durée de visite</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Cookies techniques :</strong> nécessaires au fonctionnement du site (authentification, panier)</span>
                    </li>
                    <li className="flex items-start space-x-2">
                      <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                      <span><strong>Données d'utilisation :</strong> interactions avec le site, préférences de navigation</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Finalités */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <UserCheck className="h-6 w-6 text-orange-500 mr-2" />
              Finalités du traitement
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Nous utilisons vos données personnelles pour les finalités suivantes :</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Gestion des commandes</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Traitement des réservations</li>
                    <li>• Facturation et paiement</li>
                    <li>• Livraison et retour</li>
                    <li>• Service client</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Communication</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Confirmation des commandes</li>
                    <li>• Newsletter (avec consentement)</li>
                    <li>• Support technique</li>
                    <li>• Informations commerciales</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Amélioration du service</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Analyse d'utilisation</li>
                    <li>• Personnalisation</li>
                    <li>• Développement de fonctionnalités</li>
                    <li>• Statistiques anonymisées</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Obligations légales</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Conservation comptable</li>
                    <li>• Lutte contre la fraude</li>
                    <li>• Respect des réglementations</li>
                    <li>• Sécurité des données</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Base légale */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Lock className="h-6 w-6 text-orange-500 mr-2" />
              Base légale du traitement
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Le traitement de vos données personnelles est fondé sur :</p>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Exécution du contrat :</strong> traitement nécessaire à l'exécution de nos services de location</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Intérêt légitime :</strong> amélioration de nos services et communication commerciale</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Consentement :</strong> pour l'envoi de newsletters et communications marketing</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Obligation légale :</strong> conservation des données comptables et fiscales</p>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Conservation */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Calendar className="h-6 w-6 text-orange-500 mr-2" />
              Durée de conservation
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Nous conservons vos données personnelles pendant les durées suivantes :</p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span><strong>Données clients actifs :</strong></span>
                    <span className="text-orange-600 font-semibold">3 ans après la dernière interaction</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span><strong>Données comptables :</strong></span>
                    <span className="text-orange-600 font-semibold">10 ans (obligation légale)</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span><strong>Cookies techniques :</strong></span>
                    <span className="text-orange-600 font-semibold">13 mois maximum</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span><strong>Newsletter :</strong></span>
                    <span className="text-orange-600 font-semibold">Jusqu'au désabonnement</span>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Partage des données */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <AlertTriangle className="h-6 w-6 text-orange-500 mr-2" />
              Partage et transfert des données
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Nous ne vendons jamais vos données personnelles. Nous pouvons partager vos informations avec :</p>
              <div className="space-y-3">
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Prestataires de services :</strong> hébergement (IONOS), paiement, transport, uniquement pour les services nécessaires</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Autorités compétentes :</strong> en cas d'obligation légale ou de demande judiciaire</p>
                  </div>
                </div>
                <div className="flex items-start space-x-3">
                  <div className="w-2 h-2 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                  <div>
                    <p><strong>Partenaires commerciaux :</strong> uniquement avec votre consentement explicite</p>
                  </div>
                </div>
              </div>
              <div className="bg-gray-50 p-4 rounded-lg">
                <p className="text-gray-800 font-semibold">
                  <strong>Important :</strong> Aucun transfert de données n'est effectué vers des pays hors Union Européenne sans garanties appropriées.
                </p>
              </div>
            </div>
          </section>

          {/* Droits des utilisateurs */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <UserCheck className="h-6 w-6 text-orange-500 mr-2" />
              Vos droits
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Conformément au RGPD, vous disposez des droits suivants :</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="space-y-3">
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit d'accès :</strong> obtenir une copie de vos données</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit de rectification :</strong> corriger vos données inexactes</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit d'effacement :</strong> supprimer vos données</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit à la limitation :</strong> restreindre le traitement</p>
                    </div>
                  </div>
                </div>
                <div className="space-y-3">
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit à la portabilité :</strong> récupérer vos données</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit d'opposition :</strong> vous opposer au traitement</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Retrait du consentement :</strong> à tout moment</p>
                    </div>
                  </div>
                  <div className="flex items-start space-x-2">
                    <div className="w-1.5 h-1.5 bg-gray-500 rounded-full mt-2 flex-shrink-0"></div>
                    <div>
                      <p><strong>Droit de plainte :</strong> auprès de la CNIL</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>

          {/* Sécurité */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Lock className="h-6 w-6 text-orange-500 mr-2" />
              Sécurité des données
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Nous mettons en œuvre des mesures techniques et organisationnelles appropriées pour protéger vos données :</p>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Mesures techniques</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Chiffrement SSL/TLS</li>
                    <li>• Authentification sécurisée</li>
                    <li>• Sauvegardes régulières</li>
                    <li>• Surveillance des accès</li>
                  </ul>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h4 className="font-semibold text-gray-900 mb-2">Mesures organisationnelles</h4>
                  <ul className="text-gray-700 space-y-1 text-sm">
                    <li>• Accès limité au personnel</li>
                    <li>• Formation à la protection des données</li>
                    <li>• Politiques de sécurité strictes</li>
                    <li>• Audit régulier des systèmes</li>
                  </ul>
                </div>
              </div>
            </div>
          </section>

          {/* Cookies */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Eye className="h-6 w-6 text-orange-500 mr-2" />
              Cookies et technologies similaires
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Notre site utilise des technologies de stockage local pour le bon fonctionnement :</p>
              <div className="bg-gray-50 p-4 rounded-lg">
                <div className="space-y-3">
                  <div className="flex justify-between items-center">
                    <span><strong>JWT (JSON Web Tokens) :</strong> Authentification utilisateur</span>
                    <span className="text-gray-700 font-semibold">7 jours maximum</span>
                  </div>
                  <div className="flex justify-between items-center">
                    <span><strong>Stockage local :</strong> Panier et préférences</span>
                    <span className="text-gray-700 font-semibold">Persistant</span>
                  </div>
                </div>
              </div>
              <p className="text-sm text-gray-600">
                <strong>Note :</strong> Aucun cookie de tracking ou de publicité n'est utilisé. Le stockage local peut être effacé via les paramètres de votre navigateur, mais cela peut affecter le fonctionnement du site.
              </p>
            </div>
          </section>

          {/* Contact */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Mail className="h-6 w-6 text-orange-500 mr-2" />
              Contact et exercice de vos droits
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>Pour exercer vos droits ou pour toute question relative à cette politique de confidentialité :</p>
              <div className="bg-gray-50 p-6 rounded-lg">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                  <div className="flex items-center space-x-3">
                    <Mail className="h-5 w-5 text-gray-600" />
                    <div>
                      <p className="font-semibold">Email</p>
                      <p>contact@flightcasefwi.com</p>
                    </div>
                  </div>
                  <div className="flex items-center space-x-3">
                    <Phone className="h-5 w-5 text-gray-600" />
                    <div>
                      <p className="font-semibold">Téléphone</p>
                      <p>+590 590 265 430</p>
                    </div>
                  </div>
                </div>
                <div className="mt-4 pt-4 border-t border-gray-200">
                  <p className="text-sm text-gray-800">
                    <strong>Délai de réponse :</strong> Nous nous engageons à répondre à votre demande dans un délai maximum de 30 jours.
                  </p>
                </div>
              </div>
            </div>
          </section>

          {/* Modifications */}
          <section className="mb-8">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 flex items-center">
              <Calendar className="h-6 w-6 text-orange-500 mr-2" />
              Modifications de la politique
            </h2>
            <div className="space-y-4 text-gray-700">
              <p>
                Cette politique de confidentialité peut être modifiée pour refléter les changements dans nos pratiques ou pour d'autres raisons opérationnelles, légales ou réglementaires.
              </p>
              <p>
                Toute modification substantielle sera communiquée par email ou par un avis sur notre site web. Nous vous encourageons à consulter régulièrement cette page.
              </p>
            </div>
          </section>

          {/* Dernière mise à jour */}
          <section className="border-t pt-6">
            <div className="bg-gray-50 p-4 rounded-lg">
              <p className="text-sm text-gray-800">
                <strong>Dernière mise à jour :</strong> {new Date().toLocaleDateString('fr-FR', { 
                  year: 'numeric', 
                  month: 'long', 
                  day: 'numeric' 
                })}
              </p>
            </div>
          </section>
        </div>
      </div>
    </div>
  )
}

export default PolitiqueConfidentialite
